module.exports = __webpack_public_path__ + "static/media/warrior2.c551d8c6.png";